import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { sendMobileLoadedNotification } from '@ecs-uk/web-common-mobile-view-helpers';
import { RecurlyProvider } from '@recurly/react-recurly';
import styled, { ThemeProvider } from 'styled-components';
import nebulaTheme from '@nebula/theme';
import GlobalStyles from '@nebula/global-styles';
import { ChangePaymentMethodDrawerContent } from '../../../payment-and-billing/change-payment-method'; // eslint-disable-line
import PaymentContextProvider from '../../../../components/PaymentOrchestrator/PaymentContextProvider';
import { getEnv } from '../../../../components/Context/env';
import usePageView from '../../../../hooks/usePageView';

const Container = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
`;
const PAGE_NAME = 'ProdMoveChangePaymentMethodMobile';
const MobileChangePaymentMethod = () => {
  useEffect(() => {
    sendMobileLoadedNotification();
  }, []);
  const currentOffer = useSelector(state => state.offers?.currentOffer);
  const { REACT_APP_RECURLY_PUBLIC_KEY: key } = getEnv();

  usePageView(PAGE_NAME);

  return (
    <PaymentContextProvider upgradeOffer={currentOffer} isMethodChange isWebview>
      <RecurlyProvider publicKey={key}>
        <ThemeProvider theme={nebulaTheme}>
          <GlobalStyles />
          <Container>
            <ChangePaymentMethodDrawerContent />
          </Container>
        </ThemeProvider>
      </RecurlyProvider>
    </PaymentContextProvider>
  );
};

export default MobileChangePaymentMethod;
